<template>
  <mad-overlay v-model="value">
    <div class="row center-xs middle-xs" style="height: 100%" v-if="value">
      <div class="col-xs-fluid-24 col-md-10">
        <mad-card>
          <div style="padding: 12px 16px;">
            <div class="font-headline font-medium color-grey-800" style="margin-bottom: 16px;">
              {{ title }}
            </div>
            <file-pond
              name="test"
              ref="pond"
              class-name="my-pond"
              label-idle="Drop files here..."
              :allow-multiple="true"
              accepted-file-types="image/jpeg, image/png"
              @processfile="load"
              @init="handleFilePondInit"
              @processfilerevert="removeFile"
              @addfile="fileAdd"
            />
            <mad-datatable v-if="getAttachments && getAttachments.length > 0">
              <table>
                <thead>
                  <tr>
                    <th>File Name</th>
                    <th>Mime Type</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="file in getAttachments" :key="file.Id">
                    <td>{{ file.filename }}</td>
                    <td>{{ file.mimetype }}</td>
                    <td>
                      <mad-icon-button @click="downloadFile(file.Id)">
                        <mad-icon name="mdiDownload" class="color-blue-grey-400" size="small"></mad-icon>
                      </mad-icon-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </mad-datatable>
            <div class="clearfix">
              <div style="padding-top: 12px;" class="pull-right">
                <mad-button @click="hide" button-style="color" :disabled="buttonDisabled">
                  {{ this.$language.close }}
                </mad-button>
                <mad-button @click="confirm" class="primary" button-style="raised" :disabled="buttonDisabled">
                  <mad-icon name="mdiCheck"></mad-icon>
                  {{ this.$language.confirm }}
                </mad-button>
              </div>
            </div>
          </div>
        </mad-card>
      </div>
    </div>
  </mad-overlay>
</template>

<script>
import vueFilePond, { setOptions } from "vue-filepond";
import { apolloClient } from "@/vue-apollo";

import "filepond/dist/filepond.css";
import UPLOAD_ATTACHMENT from "@/graphql/uploadAttachment.gql";
import GET_FILES from "@/graphql/getFiles.gql";
import GET_ATTACH_URL from "@/graphql/getAttachmentUrl.gql";
import REMOVE_ATTACHMENT from "@/graphql/removeAttachment.gql";
const FilePond = vueFilePond();

setOptions({
  server: {
    process: async (fieldName, file, metadata, load, error, progress, abort) => {
      const formData = new FormData();
      formData.append(fieldName, file, file.name);
      formData.append(fieldName, JSON.stringify(metadata));
      progress(false);

      let { data } = await apolloClient.mutate({
        mutation: UPLOAD_ATTACHMENT,
        variables: {
          attachment: file,
        },
      });
      progress(true);

      if (data.uploadAttachment) {
        return load(data.uploadAttachment.Id);
      }

      return abort();
    },
    revert: async uniqueFileId => {
      await apolloClient.mutate({
        mutation: REMOVE_ATTACHMENT,
        variables: {
          fileId: uniqueFileId,
        },
      });
    },
  },
});

export default {
  components: {
    FilePond,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Upload Attachment",
    },
    files: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      pFiles: this.files.slice(),
      getAttachments: [],
      buttonDisabled: false,
    };
  },
  watch: {
    value() {
      if (this.value) {
        this.pFiles = this.files.slice();
      }
    },
  },
  methods: {
    handleFilePondInit: function() {
      this.$refs.pond.getFiles();
    },
    hide() {
      this.pFiles = [];
      this.$emit("input", false);
    },
    confirm() {
      this.$emit("returnFiles", this.pFiles);
      this.hide();
    },
    load(el, file) {
      this.pFiles.push(file.serverId);
      this.buttonDisabled = false;
    },
    removeFile(file) {
      this.pFiles = this.pFiles.filter(item => item != file.serverId);
    },
    fileAdd() {
      this.buttonDisabled = true;
    },
    async downloadFile(id) {
      let returnData = await this.$apollo.query({
        query: GET_ATTACH_URL,
        variables: {
          fileId: id,
        },
      });
      window.open(returnData.data.getAttachmentUrl, "_blank");
      // console.log(returnData.data.getAttachmentUrl);
    },
  },
  apollo: {
    getAttachments: {
      query: GET_FILES,
      variables() {
        return {
          filesId: this.pFiles,
        };
      },
    },
  },
};
</script>

<style lang="scss">
@import "@MadScss/import.scss";
.filepond--item-panel {
  background-color: $theme-accent;
}
[data-filepond-item-state="processing-complete"] .filepond--item-panel {
  background-color: $theme-primary;
}

[data-filepond-item-state="processing-complete"] {
  box-shadow: 0 8px 16px rgba($theme-primary-800, 0.24);
  border-radius: 8px;
  &::before {
    border-radius: 8px;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: 0 8px 16px rgba($theme-primary-800, 0.32);
    mix-blend-mode: multiply;
    transition: box-shadow 0.15s ease;
  }
}

.filepond--root {
  font-family: inherit;
}

// // #cfd8dc
// .filepond--panel-root {
//   // background-color: #cfd8dc;
// }

.filepond--root.filepond--hopper {
  cursor: pointer;

  label {
    cursor: pointer;
  }
}
</style>
